const Spinner = () => {
    return (
        <div className="spinner-h">
            <img src={`${window.env.SITE_DOMAIN}/Media/Image/company_loader.gif`} alt="loader"/>
        </div>
    )
}

export default Spinner;